import React, { useCallback } from 'react';
import { Box, Divider } from '@mui/material';

import { Typography } from '@occc-app/design-system';

import { DeleteIcon } from './WalletSteering/components/DeleteIcon';

interface IFormArrayItemSectionProps {
  index: number;
  title: string | React.ReactNode;
  isDeleteIconShown: boolean;
  onDeleteClick(index: number): void;
}

export const FormArrayItemSection: React.FC<IFormArrayItemSectionProps> = ({
  index,
  title,
  isDeleteIconShown,
  onDeleteClick,
}) => {
  const handleDeleteClick = useCallback(() => onDeleteClick(index), [index, onDeleteClick]);
  return (
    <>
      {index > 0 ? <Divider sx={{ mt: 2.5, mb: 3 }} /> : null}
      <Box
        sx={{ minHeight: '32px', mt: -1, mb: 1 }}
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <Typography variant='subtitle1'>{title}</Typography>
        {isDeleteIconShown && <DeleteIcon onClick={handleDeleteClick} />}
      </Box>
    </>
  );
};
